import React, { useContext } from "react";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import { GStore } from "../../../../context/Context";
import { CustomerDate } from "../CustomerDate/CustomerDate";

const CustomerModal = ({
  dateSelected,
  setDateSelected,
  areasData,
  handleAddCustomer,
  register,
  handleSubmit,
  setClose
}) => {
  const { english } = useContext(GStore);
 
  return (
    <div>
      {/* Put this part before </body> tag */}
      <input type="checkbox" id="add-customer-modal" className="modal-toggle" />
      <label htmlFor="add-customer-modal" className="modal cursor-pointer">
        <label className="modal-box relative" htmlFor="">
          <h3 className="text-lg font-bold">
            <ConvertEnglish
              english={"ADD A NEW customer"}
              bangla={"নতুন কালেক্টর সংযোগ করুন"}
            />
          </h3>
          <div className="my-5">
            <form onSubmit={handleSubmit(handleAddCustomer)}>
              <input
                type="number"
                {...register("customerId")}
                placeholder={english ? "Id" : "আইডি"}
                className="input input-bordered w-full "
                required
              />
              <input
                type="text"
                {...register("customerName")}
                placeholder={english ? "Name" : "নাম"}
                className="input input-bordered w-full mt-5 "
                required
              />

              <select
                {...register("customerArea")}
                className="select select-bordered  w-full mt-5"
              >
                {areasData &&
                  areasData.map((areaData) => (
                    <option key={areaData._id}>{areaData.area}</option>
                  ))}
              </select>
              <h3 className="mt-3 ml-2">
                <small>
                  <ConvertEnglish
                    english={"Holding , House Name , Floor"}
                    bangla={" * বাড়ীর হোল্ডিং , বাড়ীর নাম , তলা"}
                  />
                </small>
              </h3>
              <div className="grid grid-cols-3 gap-2">
                <input
                  type="text"
                  {...register("holding")}
                  placeholder={english ? "Holding" : "  হোল্ডিং"}
                  className="input input-bordered w-full mt-1"
                  required
                />
                <input
                  type="text"
                  {...register("house")}
                  placeholder={english ? "House Name" : " নাম "}
                  className="input input-bordered w-full mt-1"
                  required
                />
                <input
                  type="text"
                  {...register("floor")}
                  placeholder={english ? "floor" : " তলা"}
                  className="input input-bordered w-full mt-1"
                  required
                />
              </div>
              <div className="flex justify-center">
                <CustomerDate
                  dateSelected={dateSelected && dateSelected}
                  setDateSelected={setDateSelected && setDateSelected}
                ></CustomerDate>
              </div>
              <input
                type="number"
                {...register("monthlyFee")}
                placeholder={english ? "MonthlyFee" : "মাসিক ফি"}
                className="input input-bordered w-full mt-5"
                required
              />
              <input
                type="number"
                {...register("stupidity")}
                placeholder={english ? "stupidity" : "বকেয়া"}
                className="input input-bordered w-full mt-5"
                required
              />
              <input
                type="number"
                {...register("addFee")}
                placeholder={english ? "addFee" : "সংযোগ ফি"}
                className="input input-bordered w-full mt-5"
                
              />
              
              <input
                type="number"
                {...register("customerNumber")}
                placeholder={english ? "Number" : "নাম্বার"}
                className="input input-bordered w-full mt-5"
                required
              />

              <div className="mt-5">
                <button
                 type="submit" className="btn btn-outline w-full">
                  <ConvertEnglish
                    english={"ADD Customer"}
                    bangla={"সংযোগ করুন"}
                  />
                </button>
              </div>
            </form>
          </div>
        </label>
      </label>
    </div>
  );
};
export default CustomerModal;
